export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-50/80">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-base text-background-50"></i>
              </span>
              <span className="text-base font-heading font-bold text-background-50">
                6080新视觉影院
              </span>
            </div>
            <p className="text-sm text-background-50/50 leading-relaxed mb-5">
              6080新视觉影院是专业的免费高清电影在线观看平台，提供最新电影、电视剧全集流畅播放服务，极速秒开不缓冲，让每一位影迷都能畅享极致的观影体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:text-primary-400 hover:bg-background-50/15 cursor-pointer transition-colors">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:text-primary-400 hover:bg-background-50/15 cursor-pointer transition-colors">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:text-primary-400 hover:bg-background-50/15 cursor-pointer transition-colors">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '精选推荐', href: '#cards' },
                { label: '热门话题', href: '#topics' },
                { label: '热播榜单', href: '#ranking' },
                { label: '最新快讯', href: '#updates' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="text-sm text-background-50/50 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">服务支持</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '关于我们', href: '#about' },
                { label: '移动观影', href: '#app' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="text-sm text-background-50/50 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              更多合作伙伴信息敬请期待，欢迎优质内容平台与我们建立合作关系。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 6080新视觉影院. 本站所有内容仅供交流学习，不存储任何视频文件。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}